import { useEffect, useState } from "react";
import AddForm from "../../components/molecules/Forms/addForm";
import { getUserListWithDetailThunk } from "../../store/thunks/masterDataThunk";
import { useDispatch, useSelector } from "react-redux";

const DelegateAccess = (props) => {
  // --------------------------
  // PROPS
  // --------------------------
  const { isDelegateModalOpen, setIsDelegateModalOpen, setShowLoader } = props;

  //Dispatch + Custom Hooks
  const dispatch = useDispatch();
  //const currentPath = useCurrentPath();

  // --------------------------
  // REDUX STATE
  // --------------------------
  const storeLIUId = useSelector((state) => state.auth.lIUId);

  // --------------------------
  // LOCAL STATES
  // --------------------------
  const [employees, setEmployees] = useState([]);

  // --------------------------
  // USE EFFECTS
  // --------------------------
  useEffect(() => {
    dispatch(getUserListWithDetailThunk())
      .unwrap()
      .then((res) => {
        if (Array.isArray(res)) {
          const mappedEmployees = res
            ?.filter((user) => user?.empName !== undefined && user?.empID !== 1)
            ?.map((user) => ({
              label: `${user.empName} (Emp. Id. - ${user.empID})`,
              value: user.id,
            }));

          setEmployees(mappedEmployees);
        }
      });
  }, [dispatch]);

  // --------------------------
  // FORM FIELDS
  // --------------------------
  const formFields = [
    {
      isVisible: true,
      label: "Employee",
      name: "employeeID",
      rules: [
        {
          required: true,
          message: "Please select an employee",
        },
      ],
      placeholder: "Select Employee",
      type: "select",
      multiple: false,
      options: employees,
      filterOption: (input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase()),
    },

    {
      isVisible: true,
      label: "Duration",
      name: "duration",
      rules: [
        {
          required: true,
          message: "Please select duration",
        },
      ],
      placeholder: "Select duration",
      type: "rangePicker",
    },
    {
      isVisible: true,
      label: "Special Note",
      name: "specialNote",
      rules: [],
      placeholder: "Enter special note",
      type: "textarea",
    },
  ];
  return (
    <AddForm
      isVisible={isDelegateModalOpen}
      setIsVisible={setIsDelegateModalOpen}
      setShowLoader={setShowLoader}
      name="Delegate Access"
      payload={(values) => ({
        employeeID: values?.employeeID,
        duration: values?.duration,
        specialNote: values?.specialNote,
        createdAt: new Date().toISOString(),
        historySource: "backend",
        historyAction: "create",
        historyUserID: storeLIUId,
        route: "delegateAccess",
      })}
      list=""
      headers=""
      formFields={formFields}
      successMessage="Delegate access has been given successfully"
      onSuccess=""
    />
  );
};

export default DelegateAccess;
